import { Component, OnInit, ViewChild, AfterViewInit, ViewEncapsulation, Input, Injector, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { DispatchesService } from '@app/cp/shared/services/dispatches.service';
import { v_DispatchBus } from '@app/cp/shared/models/v_DispatchBus';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { BaseGridComponent } from '@app/cp/shared/base-components/base-grid.component';
import { WidgetSearch } from '@app/cp/shared/models/WidgetSearch';
import * as _ from 'lodash';
import { DashboardService } from '@app/cp/shared/services/dashboard.service';
import { DashboardWidgetEvent } from '@app/cp/shared/models/DashboardWidgetEvent';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';
import { DashboardWidgetService } from '@app/cp/shared/services/dashboardWidget.service';
import { WindowContents } from '@app/cp/shared/enums/windowContents';
import { v_QuoteGridBus } from '@app/cp/shared/models/v_QuoteGridBus';
import { SearchTarget } from '@app/cp/shared/enums/SearchTarget';
import { RowArgs, SelectionEvent } from '@progress/kendo-angular-grid';
import { filterBy, orderBy } from '@progress/kendo-data-query';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";

@Component({
    selector: 'cp-quotes-pending',
    templateUrl: './quotes-pending.component.html',
    styleUrls: ['./quotes-pending.component.scss'],
    standalone: false
})
export class QuotesPendingComponent extends BaseGridComponent<v_DispatchBus, null>  {

    subscriptions: Subscription[] = [];
    searchParam: WidgetSearch;
    constructor(globals: GlobalsService, featureFlagService: FeatureFlagService, private svc_data: DispatchesService, private svc_dashWidget: DashboardWidgetService, private svc_dashboard: DashboardService) {
        super(globals, featureFlagService);
        this.allData = this.allData.bind(this);
        this.subscriptions.push(svc_dashboard.generalWidgetRefresh$.subscribe(
            refresh => {
                this.loaderState = true;
                this.getData();
            }))
    }
    override ngOnDestroy() {
        super.ngOnDestroy();
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }
    @Input() inputData: any;
    @Input() dataFilter: WidgetSearch;
    @Input() changeCheck: string;
    @Output() openRequest = new EventEmitter<any>();

    loaderState: boolean = true;
    quotes: v_QuoteGridBus;

    public activeChildComp: number;
    public windowData: any = {};
    public showDetails: boolean = false;
    public contentTypes = WindowContents;

    initialLoad: boolean = true;

    ngOnInit() {
        this.setup(this.dataFilter);
        this.initialLoad = false;
    }

    ngOnChanges() {
        this.loaderState = true;
        if (!this.initialLoad) {
            this.setup(this.dataFilter);
        }
    }

    public selectionKey(context: RowArgs): string {
        return context.dataItem.quoteId;
    }
    getData() {
        this.loaderState = true;
        this.hideError();
        this.svc_dashboard.getDashboardQuotesPendingGrid(this.searchParam).subscribe(data => {
            if (!data) {
                this.handleNetworkError(null);
            } else {
                this.data = data;

                this.originalGridData = _.cloneDeep(data);
                this.gridData = orderBy(filterBy(this.originalGridData, this.filter), this.sort);

                this.loaderState = false;
                this.reloadIds()
            }
        },
            error => this.handleNetworkError(error));
    }

    returnError: boolean = false;

    handleNetworkError(error) {
        this.showError();
    }

    showError() {
        this.loaderState = false;
        this.returnError = true;
    }

    hideError() {
        this.returnError = false;
    }

    public setup(data: WidgetSearch) {
        this.searchParam = data;
        this.getData();
    }

    showDetailsPopup(id: string, type: number) {
        this.setReloadIds(id);
        this.svc_dashboard.openDQOIPopup(id, type);
    }

    @ViewChild(TooltipDirective) public tooltipDir: TooltipDirective;

    public showTooltip(e: MouseEvent): void {
        const element = e.target as HTMLElement;
        if ((element.nodeName === 'TD' || element.nodeName === 'TH')
            && element.offsetWidth < element.scrollWidth) {
            this.tooltipDir.toggle(element);
        } else {
            this.tooltipDir.hide();
        }
    }

    public openNewTab(linkObj: any) {
        window.open(linkObj.url, "_blank");
    }
}
